import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MensajeServices } from '../../Service/messages.services';
import { Alertas, TiposAlerta } from '../../recursos/alertas';
import { ResponseModel } from '../../models/response.model';
import { AbstractControl, FormControl, ReactiveFormsModule, FormGroupDirective, ValidatorFn, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActualizacionModel } from '../../models/actualizacion-datos.model';
import { AplicacionServices } from '../../Service/aplicacion.services';
import { environment } from '../../../environments/environment';
import { ListOption } from '../../interfaces/TipoDocOption';
import { MatSelectChange } from '@angular/material/select';
import { MatRadioChange } from '@angular/material/radio';
import { noConsecutiveDigitsValidator } from '../../compartido/validadores/no-consecutivos-digitoss.validator';
import { smartEmailValidator } from '../../compartido/validadores/correo-correcto.validator';

@Component({
  selector: 'app-datos',
  templateUrl: './datos.component.html',
  styleUrl: './datos.component.css'
})
export class DatosComponent implements OnInit {
  @Input() Constantes: any;
  @Input() Mensajes: any;
  Alertas: Alertas;
  Form: ActualizacionModel;
  submitted = false;
  vCuenta = false;
  btnDisEnviar = false;
  siteKey: string;
  TipoDocList: ListOption[] = [];
  TipoDocFiltradoList: ListOption[] = [];
  TipoPerList: ListOption[] = [];
  DeptoList: ListOption[] = [];
  MunList: ListOption[] = [];
  MedioList: ListOption[] = [{"strCodigo": "", "strDescripcion": "Seleccione"},
    {"strCodigo": "RedesSociales", "strDescripcion": "Redes sociales"},
    {"strCodigo": "Radio", "strDescripcion": "Radio"}, {"strCodigo": "TV", "strDescripcion": "TV"},
    {"strCodigo": "PaginaWeb", "strDescripcion": "Página web"}, 
    {"strCodigo": "Referido", "strDescripcion": "Referido"}, {"strCodigo": "Otro", "strDescripcion": "Otro"}];
  deptosPermitidos: number[] = [1,2,3,4,5,6];
  municipiosPermitidos: number[] = [
  324,325,330,502,989,231,235,613,270,232,530,931,790,932,
  1,60,155,207,201,241,211,70,203,205,219,221,90,245,80,84,
  95,75,79,78,86,96,320,852,862,860,856,858,800,854,808,
  810,812,818,824,806,826,760,764,770,768,712,766,700,710,
  774,300,756,716,754,370,372,606,340,460,400,476,474,406,
  468,412,458,478,410,414,418,462,464,466,472,470,600,670,
  664,610,676,674,658,660,612,614,615,626,622,624,632,673,
  678,695,718
];
  //Tooltips
  tooltip_tipoDoc: string;
  tooltip_tipoPer: string;
  tooltip_nombre: string;
  tooltip_nombre1: string;
  tooltip_apellido: string;
  tooltip_apellido1: string;
  tooltip_razonSoc: string;
  tooltip_cedula: string;
  tooltip_lugarExp: string;
  tooltip_correo: string;
  tooltip_cel: string;
  tooltip_tel: string;
  tooltip_depto: string;
  tooltip_municipio: string;
  tooltip_dir: string;
  tooltip_tipo: string;
  tooltip_modificarNomSusc: string;
  tooltip_porcPropMayor: string;
  tooltip_numCuenta: string;
  tooltip_autNotificacion: string;
  tooltip_recibirFactElect: string;
  tooltip_medio: string;
  tooltip_matCatastral: string;
  tooltip_aceptaTratDatosPer: string;
  tooltip_enviar: string;
  urlPolPriv: string;
  UrlThkPage: string;
  MensajeThkPag: string;
  
  ngOnInit(): void {
    this.CargarDeptos();
    this.CargarTipoDoc();
    this.CargarTipoPer();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.Constantes && changes.Constantes.currentValue) {
      // Procesa los datos aquí
      this.AsignarConstantes();
    }

    if(changes.Mensajes && changes.Mensajes.currentValue)
      this.AsignarTooltipsMensajes();
  }

   changeTipo(e: MatRadioChange) {
    if (e.value === 'Propietario'){
      this.actForm.get('modificarNomSusc')?.enable();
      this.actForm.get('modificarNomSusc')?.addValidators([Validators.required]);

      this.actForm.get('matCatastral')?.enable();
      this.actForm.get('matCatastral')?.addValidators([Validators.required]);
    }
    else{
    this.actForm.get('modificarNomSusc')?.setValue(null);
    this.actForm.get('modificarNomSusc')?.clearValidators();
    this.actForm.get('modificarNomSusc')?.disable();

    this.actForm.get('porcPropMayor')?.setValue(null);
    this.actForm.get('porcPropMayor')?.clearValidators();
    this.actForm.get('porcPropMayor')?.disable();

    this.actForm.get('matCatastral')?.setValue('');
    this.actForm.get('matCatastral')?.clearValidators();
    this.actForm.get('matCatastral')?.disable();
    }
      this.actForm.get('modificarNomSusc')?.updateValueAndValidity();
      this.actForm.get('porcPropMayor')?.updateValueAndValidity();
      this.actForm.get('matCatastral')?.updateValueAndValidity();
  }

  changeModNomSus(e: MatRadioChange) {
   if (e.value === 'Si') {

    this.actForm.get('porcPropMayor')?.enable();
    this.actForm.get('porcPropMayor')?.setValidators([Validators.required]);

  } else {

    this.actForm.get('porcPropMayor')?.setValue(null);
    this.actForm.get('porcPropMayor')?.clearValidators();
    this.actForm.get('porcPropMayor')?.disable();
  }

  this.actForm.get('porcPropMayor')?.updateValueAndValidity();
  }

  changePorPropMayor(e: MatRadioChange) {
  if (e.value === 'No') {
    this.Alertas.MostrarAlerta('Información', 'PorcentajePropiedad', TiposAlerta.error);
  }
  }

  onChangeTipoDoc(e: MatSelectChange): void {
    if (e.value == "NIT")
      {
        this.actForm.controls.razonSoc.enable();
        this.actForm.controls.nombre.setValue("");
        this.actForm.controls.nombre.disable();
        this.actForm.controls.nombre1.setValue("");
        this.actForm.controls.nombre1.disable();
        this.actForm.controls.apellido.setValue("");
        this.actForm.controls.apellido.disable();
        this.actForm.controls.apellido1.setValue("");
        this.actForm.controls.apellido1.disable();
      }
    else {
      this.actForm.controls.razonSoc.setValue("");
      this.actForm.controls.razonSoc.disable();
      this.actForm.controls.nombre.enable();
        this.actForm.controls.nombre1.enable();
        this.actForm.controls.apellido.enable();
        this.actForm.controls.apellido1.enable();
    }
  }

   onChangeTipoPer(e: MatSelectChange): void {
    if(e.value == "JUR")
        this.TipoDocFiltradoList = this.TipoDocList.filter(function(item) {
				return item.strCodigo == "NIT";
			});
      else
        this.TipoDocFiltradoList = this.TipoDocList.filter(function(item) {
				return item.strCodigo != "NIT";});
  }

    changeDepto(e: MatSelectChange) {
    if(e.value != "")
        this.CargarMuni(e.value);
  }

  CargarTipoDoc() {
    this._AplicacionServices.ObtenerTipoDoc().then((response: ResponseModel) => {
      if (response.StatusCode === 200) {
        this.TipoDocList = response.Data;
      }
    });
  }

   CargarTipoPer() {
    this._AplicacionServices.ObtenerTipoPer().then((response: ResponseModel) => {
      if (response.StatusCode === 200) {
        this.TipoPerList = response.Data;
          this.quitarOpcLista(this.TipoPerList, 'PJE');
          this.quitarOpcLista(this.TipoPerList, 'PJN');
          this.quitarOpcLista(this.TipoPerList, 'PNE');
          this.quitarOpcLista(this.TipoPerList, 'PNN');
          this.quitarOpcLista(this.TipoPerList, 'PSC');
      }
    });
  }

   CargarMuni(depto : string) {
    this._AplicacionServices.ObtenerMuni(depto).then((response: ResponseModel) => {
      if (response.StatusCode === 200) {
         this.MunList = response.Data.filter(m =>
        this.municipiosPermitidos.includes(Number(m.strCodigo))
      );
      }
    });
  }

  CargarDeptos() {
  // AplicacionServices.HabilitarCargador = true;
    this._AplicacionServices.ObtenerDeptos().then((response: ResponseModel) => {
      if (response.StatusCode === 200) {
        this.DeptoList = response.Data.filter(d =>
        this.deptosPermitidos.includes(Number(d.strCodigo))
        );
      }
      // AplicacionServices.HabilitarCargador = false;
    });
  }

  changeCorreoObligatorio(e) {
    if (e.value == 'CorreoElectronico'){
      this.actForm.controls.correo.addValidators([Validators.required])
      this.actForm.controls.correo.updateValueAndValidity();
    }
    else{
      this.actForm.controls.correo.removeValidators([Validators.required])
      this.actForm.controls.correo.updateValueAndValidity();
    }
  }
  changeRecibirFactura(e: MatRadioChange){
    const correoControl = this.actForm.get('correo');

    if (e.value === 'Si'){
      correoControl?.addValidators([Validators.required]);
      correoControl?.updateValueAndValidity();

      this.Alertas.MostrarAlerta(
        'Informacion',
        'FacturaDigitalCorreoObligatorio',
        TiposAlerta.informacion 
      )
    }
    else{
          correoControl?.removeValidators([Validators.required]);
          correoControl?.updateValueAndValidity();
      }
  }

  quitarOpcLista(array: ListOption[], valor: string) {
    let index = this.encIndexElemArray(array, valor);
    if (index >= 0)
      array.splice(index, 1);
  }

  encIndexElemArray(array: ListOption[], valor: string) {
    let index = array.findIndex(object => {
      return object.strCodigo === valor;
    });
    return index;
  }

  public actForm = new FormGroup({
    tipoDoc: new FormControl('', [Validators.required]),
    tipoPer: new FormControl('', [Validators.required]),
    nombre: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern('^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$')]),
    nombre1: new FormControl('', [Validators.maxLength(50), Validators.pattern('^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$')]),
    apellido: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern('^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$')]),
    apellido1: new FormControl('', [Validators.maxLength(50), Validators.pattern('^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$')]),
    razonSoc: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern('^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$')]),
    cedula: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.pattern('^[0-9]+$')]),
    correo: new FormControl('', [Validators.maxLength(60), smartEmailValidator()]),
    cel: new FormControl('', [Validators.required, Validators.minLength(10), noConsecutiveDigitsValidator(), Validators.pattern('^[0-9]+$')]),
    lugarExp: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern('^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$')]),
    tel: new FormControl('', [Validators.minLength(10), noConsecutiveDigitsValidator(), Validators.pattern('^[0-9]+$')]),
    depto: new FormControl('', [Validators.required]),
    municipio: new FormControl('', [Validators.required]),
    dir: new FormControl('', [Validators.required, Validators.maxLength(240)]),
    tipo: new FormControl('', [Validators.required]),
    modificarNomSusc: new FormControl({ value: null, disabled: true }, [Validators.required]),
    porcPropMayor: new FormControl({ value: null, disabled: true }, [Validators.required]),
    numCuenta: new FormControl('', [Validators.required, Validators.maxLength(12), Validators.pattern('^[0-9]+$')]),
    autNotificacion: new FormControl('', [Validators.required]),
    aceptaTratDatosPer: new FormControl(false, [Validators.requiredTrue]),
    recibirFactElect: new FormControl('', [Validators.required]),
    // matCatastral: new FormControl('', [Validators.maxLength(9), Validators.pattern('^[0-9]{3}\-[0-9]{5}$')]),
    medio: new FormControl('', [Validators.required]),
    matCatastral: new FormControl('', [Validators.maxLength(30), Validators.pattern('^[0-9]+$')]),
    recaptcha: new FormControl('', [Validators.required])
  });

  constructor(private _MensajeServices: MensajeServices, private _AplicacionServices: AplicacionServices) {
    this.Alertas = new Alertas(_MensajeServices);
    this.Form = new ActualizacionModel();
    this.siteKey = environment.recaptcha.siteKey;
  }

  AsignarTooltipsMensajes(): void {
      this.tooltip_nombre = this.Mensajes['tooltip_nombre'];
      this.tooltip_nombre1 = this.Mensajes['tooltip_nombre1'];
      this.tooltip_apellido = this.Mensajes['tooltip_apellido'];
      this.tooltip_apellido1 = this.Mensajes['tooltip_apellido1'];
      this.tooltip_cedula = this.Mensajes['tooltip_cedula'];
      this.tooltip_correo = this.Mensajes['tooltip_correo'];
      this.tooltip_cel = this.Mensajes['tooltip_cel'];
      this.tooltip_tel = this.Mensajes['tooltip_tel'];
      this.tooltip_dir = this.Mensajes['tooltip_dir'];
      this.tooltip_tipo = this.Mensajes['tooltip_tipo'];
      this.tooltip_numCuenta = this.Mensajes['tooltip_numCuenta'];
      this.tooltip_autNotificacion = this.Mensajes['tooltip_autNotificacion'];
      this.tooltip_recibirFactElect = this.Mensajes['tooltip_recibirFactElect'];
      this.tooltip_matCatastral = this.Mensajes['tooltip_matCatastral'];
      this.tooltip_aceptaTratDatosPer = this.Mensajes['tooltip_aceptaTratDatosPer'];
      this.tooltip_enviar = this.Mensajes['tooltip_enviar'];
      this.tooltip_tipoPer = this.Mensajes['tooltip_tipoPer'];
      this.tooltip_tipoDoc = this.Mensajes['tooltip_tipoDoc'];
      this.tooltip_lugarExp = this.Mensajes['tooltip_lugarExp'];
      this.tooltip_depto = this.Mensajes['tooltip_depto'];
      this.tooltip_municipio = this.Mensajes['tooltip_municipio'];
      this.tooltip_modificarNomSusc = this.Mensajes['tooltip_modificarNomSusc'];
      this.tooltip_porcPropMayor = this.Mensajes['tooltip_porcPropMayor'];
      this.tooltip_medio = this.Mensajes['tooltip_medio'];
      this.MensajeThkPag = this.Mensajes['InformacionRecibida'];
      this.tooltip_razonSoc = this.Mensajes['tooltip_razonSoc'];
  }

  AsignarConstantes(): void {
    this.urlPolPriv = this.Constantes['UrlPolPriv'];
    this.UrlThkPage = this.Constantes['UrlThankyouPage'];
  }

  NoEjecutarForm = (event) => { return false };

  SoloNumeros(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ValidarCuentaCliente(event){
    if (event.target.value !== '' && event.target.value !== undefined && event.target.value !== null){
      this._AplicacionServices.ValidarCuentaCliente(this.actForm.value.numCuenta).then(data => {
        if (data.StatusCode === 200) {
          if(data.Data)
            this.vCuenta = true;
          else
            {
              this.Alertas.MostrarAlerta('Revisa la cuenta', 'CuentaNoExiste', TiposAlerta.error);
              this.vCuenta = false;
            }
        }
        else {
          this.Alertas.MostrarAlertaConTexto('', data.Message, TiposAlerta.error);
          this.vCuenta = false;
        }
        // AplicacionServices.HabilidarCargador = false;
      });
    }
  }

  SolicitudSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.actForm.invalid /*|| this.vCuenta == false*/) {
      this.actForm.markAllAsTouched();
      return;
  }
    AplicacionServices.HabilitarCargador = true;
    this.btnDisEnviar = true;
    this.asignarValores();
    
    this._AplicacionServices.NuevaSolActualizacion(this.Form).then(data => {
      if (data.StatusCode === 200)
        window.location.replace(`${this.UrlThkPage}?Mensaje=${this.MensajeThkPag}`);
      else
        {
          AplicacionServices.HabilitarCargador = false;
          this.Alertas.MostrarAlertaConTexto('', data.Message, TiposAlerta.error);
        }
    });
  }

  private asignarValores() {
    this.Form.TipoDoc = this.actForm.value.tipoDoc.toUpperCase() ?? '';
    this.Form.TipoPersona = this.actForm.value.tipoPer.toUpperCase() ?? '';
    const razonSoc = this.actForm.get('razonSoc')?.value;
    this.Form.RazonSoc = typeof razonSoc === 'string' ? razonSoc.toUpperCase() : '';
    const nombre = this.actForm.get('nombre')?.value;
    this.Form.Nombre = typeof nombre === 'string' ? nombre.toUpperCase() : '';
    const nombre1 = this.actForm.get('nombre1')?.value;
    this.Form.Nombre1 = typeof nombre1 === 'string' ? nombre1.toUpperCase() : '';
    const apellido = this.actForm.get('apellido')?.value;
    this.Form.Apellido = typeof apellido === 'string' ? apellido.toUpperCase() : '';
    const apellido1 = this.actForm.get('apellido1')?.value;
    this.Form.Apellido1 = typeof apellido1 === 'string' ? apellido1.toUpperCase() : '';
    this.Form.NombreCompleto = this.nombreCompleto;
    this.Form.Identificacion = this.actForm.value.cedula ?? '';
    this.Form.LugarExpDoc = this.actForm.value.lugarExp.toUpperCase() ?? '';
    this.Form.Correo = this.actForm.value.correo.toUpperCase() ?? '';
    this.Form.Celular = this.actForm.value.cel ?? '';
    this.Form.Telefono = this.actForm.value.tel ?? '';
    this.Form.DeptoCod = this.actForm.value.depto ?? '';
    this.Form.MunCod = this.actForm.value.municipio ?? '';
    this.Form.Direccion = this.actForm.value.dir.toUpperCase() ?? '';
    this.Form.EsPropietario = this.actForm.value.tipo  == 'Propietario'? true: false;
    this.Form.ModificarNomSusc = this.actForm.value.modificarNomSusc  == 'Si'? true: false;
    this.Form.PorcPropMayor = this.actForm.value.porcPropMayor  == 'Si'? true: false;
    this.Form.NumeroCuenta = this.actForm.value.numCuenta ?? '';
    this.Form.AutorizaInfo = this.actForm.value.autNotificacion.toUpperCase() ?? '';
    this.Form.AceptaTratDatosPer = this.actForm.value.aceptaTratDatosPer? true: false;
    this.Form.RecibirFactElect = this.actForm.value.recibirFactElect == 'Si'? true: false;
    // if (typeof this.actForm.value.matCatastral === 'object' && this.actForm.value.matCatastral !== null){
    //   let matCatValor = { area: '', exchange: ''};
    //   matCatValor = this.actForm.value.matCatastral;
    //   this.Form.MatCatastral = `${matCatValor.area}-${matCatValor.exchange}`;
    //   }
    // else
    //   this.Form.MatCatastral = '';
    this.Form.MatCatastral = this.actForm.value.matCatastral ?? '';
  }

  get nombreCompleto(): string {
  const { nombre, nombre1, apellido, apellido1 } = this.actForm.controls;

  return [nombre.value, nombre1.value, apellido.value, apellido1.value]
    .filter(v => v?.trim())
    .map(v => v!.trim())
    .join(' ')
    .toUpperCase();
}
 
}



